import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'
import { getLaborerEToIRequests } from 'redux/actionCreators/laborerPortalAPI/newDlTransfers'
import { GetLaborerEToIRequestsResponse, LaborerEToIRequestFomBe } from 'api/laborerPortalAPI/newDlTransferApi'
import { LaborerEToIRequest } from 'common/types/commonTypes'

type State = {
  requestParams: {
    page: number
  }
  requests: Array<LaborerEToIRequest>
  lastPage: number
} & Status

const initialState: State = {
  requestParams: {
    page: 0,
  },
  requests: [],
  lastPage: 0,
  isLoading: false,
  success: false,
  fail: false,
}

const convertLaborerEToIRequestToState = (request: LaborerEToIRequestFomBe): LaborerEToIRequest => {
  return {
    id: request.id,
    createdAt: request.created_at,
    updatedAt: request.updated_at,
    status: request.status,
  }
}

const convertRequestsToState = (data: GetLaborerEToIRequestsResponse) => {
  return data.data.map((request) => convertLaborerEToIRequestToState(request))
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_E_TO_I_REQUESTS_ASYNC,
    Actions.GET_LABORER_E_TO_I_REQUESTS_SUCCESS,
    Actions.GET_LABORER_E_TO_I_REQUESTS_FAIL,
    GetLaborerEToIRequestsResponse,
    {},
    {},
    ReturnType<typeof getLaborerEToIRequests>['payload']
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_E_TO_I_REQUESTS_ASYNC: {
      const {
        params: { page = 0 },
      } = action.callAPIActionPayload
      return {
        ...state,
        ...action.status,
        requestParams: {
          page: page,
        },
      }
    }
    case Actions.GET_LABORER_E_TO_I_REQUESTS_SUCCESS: {
      return {
        ...state,
        ...action.status,
        requests: convertRequestsToState(action.payload),
        lastPage: action.payload.meta.last_page || 0,
      }
    }
    case Actions.GET_LABORER_E_TO_I_REQUESTS_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
